import React, { useContext } from "react";

import { DataContext } from "../../../../../../../providers/GasCheckoutDataProvider";
import NewInput from "../../../../../../shared/forms/NewInput";
import { SalutationSelect } from "../../../../../../shared/forms/NewSelect";

const ContactData = () => {
    const dataContext = useContext(DataContext);

    const { billingAddressData } = dataContext.data;
    const {
        setBillingAddressData,
        addFormError,
        clearFormError,
        hasFormErrorAt,
    } = dataContext.actions;

    const handleChange = (event) => {
        setBillingAddressData({
            ...billingAddressData,
            ...{ [event.target.name]: event.target.value },
        });
    };

    return (
        <div>
            <SalutationSelect
                withField
                name="billingsalutation"
                onChange={handleChange}
                value={billingAddressData.billingsalutation}
            />

            <NewInput
                placeholder="Vorname"
                name="billingfirstname"
                onChange={handleChange}
                value={billingAddressData.billingfirstname}
                validation="name"
                forceError={hasFormErrorAt("billingfirstname")}
                onError={() => addFormError("billingfirstname")}
                onErrorSolved={() => clearFormError("billingfirstname")}
                withField
            />

            <NewInput
                placeholder="Nachname"
                name="billinglastname"
                onChange={handleChange}
                value={billingAddressData.billinglastname}
                validation="name"
                forceError={hasFormErrorAt("billinglastname")}
                onError={() => addFormError("billinglastname")}
                onErrorSolved={() => clearFormError("billinglastname")}
                withField
            />
            <NewInput
                placeholder="E-Mail"
                name="billingemail"
                onChange={handleChange}
                value={billingAddressData.billingemail}
                validation="email"
                forceError={hasFormErrorAt("billingemail")}
                onError={() => addFormError("billingemail")}
                onErrorSolved={() => clearFormError("billingemail")}
                withField
            />
            <NewInput
                placeholder="Telefonnummer"
                name="billingphone"
                onChange={handleChange}
                value={billingAddressData.billingphone}
                validation="phone"
                forceError={hasFormErrorAt("billingphone")}
                onError={() => addFormError("billingphone")}
                onErrorSolved={() => clearFormError("billingphone")}
                withField
            />
        </div>
    );
};

export default ContactData;
